import React from 'react'
import Search from './Search';
import Stories from './Stories';
import Pagination from './Pagination';

import './App.css';



export const App = () => {

  return (
     
    <>
   
    <Search/>
    <Pagination/>
    <Stories/>
   
    </>
    
  )
}

export default App;
